import React, { Component } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Tabs,
  Tab,
  Button,
  Grid,
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  CircularProgress,
  InputAdornment,
  Switch,
  Avatar,
  Stack,
  Grid2,
  Alert,
} from "@mui/material";
import { withStyles } from "@mui/styles";

import TimeIcon from "@mui/icons-material/AccessTime";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "react-datepicker/dist/react-datepicker.css";

import RevaLogo from "../../../assets/iso-white.svg";
import { matchesUpdateRoute, matchesShowRoute } from "../../../network/api-routes";
import performRequest from "../../../network/perform-request";
import { withUserContext } from "../../hoc/withUserContext";
import PlaceIcon from "@mui/icons-material/Place";
import { FormControlLabel } from "@mui/material";
import { Checkbox } from "@mui/material";
import MatchScoreDetails from "../../common/MatchScoreDetails";
import RevaText from "components/common/RevaText";
import { injectIntl } from "react-intl";
import { DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import CTAButton from "components/common/CTAButton";
import { formatMatchIdentity } from "components/common/matchIdentity";
import {
  isValidScoreGrid,
  isValidScoreInput,
  parseScoreCsv,
  serializeScoreGrid,
  winnerFromScores,
} from "./matchScoreUtils";
import { parseMatchDuration } from "./matchDurationUtils";
const CLOSED = "closed";

const styles = (theme) => ({
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  scoreTableContainer: {
    width: "100%",
    overflow: "auto",
  },
  score: {
    width: 70,
  },
  scoreInput: {
    fontSize: 16,
  },
  detailsPanel: {
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    overflow: "hidden",
  },
  detailsSection: {
    padding: 24,
    [theme.breakpoints.down("sm")]: {
      padding: 16,
    },
  },
  subPanel: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 10,
    backgroundColor: theme.palette.background.skeleton,
    padding: 20,
    [theme.breakpoints.down("sm")]: {
      padding: 14,
    },
  },
  controlsBar: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 10,
    backgroundColor: theme.palette.background.skeleton,
  },
  teamCard: {
    flex: 1,
    minHeight: 140,
    textAlign: "center",
    borderRadius: 10,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.skeleton,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: 16,
    gap: 10,
  },
  teamAvatar: {
    width: 58,
    height: 58,
    margin: "0 auto",
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
  },
  vsLabel: {
    margin: "auto",
    fontSize: 18,
    fontWeight: 700,
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    fontStyle: "italic",
  },
  scoreTableCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 10,
    overflow: "hidden",
    backgroundColor: theme.palette.background.skeleton,
  },
  scoreHeaderCell: {
    fontWeight: 700,
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.base,
    borderColor: theme.palette.divider,
  },
  fieldCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 10,
    backgroundColor: theme.palette.background.skeleton,
    padding: 14,
  },
  winnerCard: {
    flex: 1,
    cursor: "pointer",
    borderRadius: 10,
    border: `2px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.base,
    transition: "all 0.15s ease-in-out",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    padding: "14px 20px",
    textAlign: "center",
    minHeight: 52,
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.background.skeleton,
    },
  },
  winnerCardSelected: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.background.skeleton,
    "&:hover": {
      backgroundColor: theme.palette.background.skeleton,
    },
  },
  saveSection: {
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.action.hover,
    padding: "20px 24px",
    display: "flex",
    justifyContent: "center",
  },
  scoreDetails: {
    padding: "15px 16px",
    borderLeftWidth: 1,
    borderLeftStyle: "solid",
    borderColor: theme.palette.divider,
  },
});

const MATCH_IN_PROGRESS = 0;
const TIE = -1;

const TABS = {
  details: 0,
  score: 1,
  scoreDetails: 2,
};

class EditMatchModal extends Component {
  constructor(props) {
    super(props);

    let tabIndex = 0;
    if (this.props.tabName) {
      tabIndex = TABS[this.props.tabName];
    }

    this.state = {
      tabIndex,
      ready: false,
      startDate: null,
      dateToShow: null,
      showScoreDetailsTab: false,
      hasLive: false,
      channel_name: "",
      liveNow: false,
      hasSuperTiebreak: false,
      savingScore: false,
      scoreError: null,
      savingSchedule: false,
      scheduleError: null,
    };

    this.handleSpaceChange = this.handleSpaceChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleTextInputChange = this.handleTextInputChange.bind(this);
  }

  componentDidMount() {
    this.fetch();
  }

  fetch() {
    const { user } = this.props;
    performRequest(
      "POST",
      matchesShowRoute,
      {
        match_id: this.props.matchId,
      },
      true,
      user,
    )
      .then((result) => {
        const matchInfo = result.data.data;
        const scoresBySet = matchInfo.scores_csv && matchInfo.scores_csv.split(",");
        const tournament = matchInfo.tournament.data;
        const playerScores = parseScoreCsv(matchInfo.scores_csv);

        const dateToShow = matchInfo.scheduled_time && dayjs(matchInfo.scheduled_time);
        let defaultScores = [["0", "0"]];
        if (tournament.default_sets > 1) {
          for (let i = 0; i < tournament.default_sets - 1; i++) {
            defaultScores.push(["0", "0"]);
          }
        }

        let winner = matchInfo.winner_id;
        if (matchInfo.in_progress) {
          winner = MATCH_IN_PROGRESS;
        }

        this.setState({
          matchInfo,
          playerScores: playerScores.length ? playerScores : defaultScores,
          scoresBySet: scoresBySet,
          winner,
          dateToShow,
          startDate: matchInfo.scheduled_time,
          spaces: result.data.meta.spaces.data,
          showScoreDetailsTab: result.data.meta.score_details_allowed,
          selectedSpaceId: this.resolveSelectedCourtKey(matchInfo, result.data.meta.spaces.data),
          walkover: matchInfo.is_walkover,
          duration: matchInfo.match_duration,
          ready: true,
          tournament,
          hasLive: matchInfo.has_live,
          channel_name: matchInfo.channel_name,
          liveNow: matchInfo.live_now,
          hasSuperTiebreak: !!matchInfo.has_super_tiebreak,
          resultRevision: matchInfo.result_revision,
          scoreError:
            matchInfo.scores_csv && !isValidScoreGrid(playerScores)
              ? "El puntaje guardado tiene un formato inválido. Corrígelo antes de volver a guardar."
              : null,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  updateMatch() {
    const { user, onSubmitScore, hasClosedDependents, intl } = this.props;
    const { winner, walkover, matchInfo } = this.state;
    const scoresCSV = serializeScoreGrid(this.state.playerScores);

    if (!scoresCSV) {
      this.setState({ scoreError: "Todos los puntajes deben ser números enteros mayores o iguales a cero." });
      return;
    }

    if (
      hasClosedDependents &&
      matchInfo.state === CLOSED &&
      winner !== TIE &&
      winner !== MATCH_IN_PROGRESS &&
      winner !== matchInfo.winner_id &&
      !window.confirm(intl.formatMessage({ id: "groupStage.twoRounds.invalidateConfirmation" }))
    ) {
      return;
    }

    const data = {
      match_id: matchInfo.id,
      winner_id: winner === MATCH_IN_PROGRESS || winner === TIE ? null : winner,
      scores_csv: scoresCSV,
      is_tie: winner === TIE,
      in_progress: winner === MATCH_IN_PROGRESS,
      is_walkover: walkover,
      has_super_tiebreak: this.state.hasSuperTiebreak,
      result_revision: this.state.resultRevision,
      result_source: "organizer_web",
    };

    this.setState({ savingScore: true, scoreError: null });
    performRequest("POST", matchesUpdateRoute, data, true, user)
      .then((result) => {
        onSubmitScore(result.data);
      })
      .catch((error) => {
        this.setState({
          savingScore: false,
          scoreError:
            error?.response?.data?.message ||
            "No se pudo guardar el resultado. Actualiza el partido e inténtalo nuevamente.",
        });
      });
  }

  update(callback) {
    const { user } = this.props;
    const { matchInfo } = this.state;
    const duration = this.state.startDate ? parseMatchDuration(this.state.duration) : null;

    if (this.state.startDate && duration === null) {
      this.setState({ scheduleError: "La duración debe ser un número entero entre 1 y 1440 minutos." });
      return;
    }

    const data = {
      match_id: matchInfo.id,
      scheduled_time: this.state.startDate,
      ...this.selectedCourtPayload(),
      ...(duration !== null ? { duration } : {}),
      has_live: this.state.hasLive,
      channel_name: this.state.hasLive ? this.state.channel_name : null,
    };
    this.setState({ savingSchedule: true, scheduleError: null });
    performRequest("POST", matchesUpdateRoute, data, true, user)
      .then((result) => {
        this.setState({ savingSchedule: false });
        if (callback) {
          callback(result.data);
        }
      })
      .catch((error) => {
        this.setState({
          savingSchedule: false,
          scheduleError: error?.response?.data?.message || "No se pudo guardar la programación del partido.",
        });
      });
  }

  handleChange = (setIndex, playerIndex) => (event) => {
    const { matchInfo } = this.state;
    const participants = [matchInfo.player1.data, matchInfo.player2.data];
    const score = event.target.value;

    if (!isValidScoreInput(score)) {
      this.setState({ scoreError: "Solo se permiten números enteros mayores o iguales a cero." });
      return;
    }

    const newPlayerScores = this.state.playerScores.map((set, currentSetIndex) =>
      currentSetIndex === setIndex
        ? set.map((currentScore, currentPlayerIndex) => (currentPlayerIndex === playerIndex ? score : currentScore))
        : [...set],
    );

    this.setState({
      playerScores: newPlayerScores,
      winner: winnerFromScores(newPlayerScores, participants.map((participant) => participant.id)),
      scoreError: null,
    });
  };

  handleSelectChange(event) {
    this.setState({ ...this.state, [event.target.name]: event.target.value });
  }

  handleInputChange(event) {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  }

  handleSwitchChange(event) {
    const targetName = event.target.name;

    this.setState((previousState) => ({
      [targetName]: !previousState[targetName],
      scoreError: null,
    }));
  }

  onSetChange(action) {
    const participants = [this.state.matchInfo.player1.data.id, this.state.matchInfo.player2.data.id];

    this.setState((previousState) => {
      const playerScores =
        action === "add"
          ? [...previousState.playerScores, ["0", "0"]]
          : previousState.playerScores.slice(0, -1);

      return {
        playerScores,
        winner: winnerFromScores(playerScores, participants),
        scoreError: null,
      };
    });
  }

  handleDateChange(date) {
    console.log(date);
    this.setState({
      startDate: date || null,
    });
  }

  handleSpaceChange(event) {
    this.setState({
      selectedSpaceId: event.target.value,
    });
  }

  resolveSelectedCourtKey(matchInfo, spaces) {
    const options = spaces || [];
    if (matchInfo.tournament_field_id) {
      const keyed = options.find(
        (space) => space.tournament_field_id === matchInfo.tournament_field_id || space.id === `tf-${matchInfo.tournament_field_id}`,
      );
      return keyed?.id || `tf-${matchInfo.tournament_field_id}`;
    }
    if (matchInfo.space_id) {
      const keyed = options.find(
        (space) => space.space_id === matchInfo.space_id || space.id === matchInfo.space_id,
      );
      return keyed?.id || matchInfo.space_id;
    }
    return "";
  }

  selectedCourtPayload() {
    const selected = (this.state.spaces || []).find((space) => space.id === this.state.selectedSpaceId);
    if (selected?.tournament_field_id) {
      return {
        tournament_field_id: selected.tournament_field_id,
        space_id: selected.space_id || null,
      };
    }
    if (this.state.selectedSpaceId) {
      return { space_id: this.state.selectedSpaceId };
    }
    return { space_id: null, tournament_field_id: null };
  }

  handleTextInputChange = (name) => (event) => {
    this.setState({
      [name]: event.target.value,
    });
  };

  renderTeamScoreDetails(participant) {
    const { matchInfo } = this.state;
    const team = participant.team?.data;
    const teamPlayers = team?.players.data;
    const standings = matchInfo.score_details ? matchInfo.score_details["standingsByPlayerId"] : [];
    const goalers = teamPlayers?.filter((teamPlayer) => standings[teamPlayer.id]?.goals > 0) || [];
    const warnedPlayers = teamPlayers?.filter((teamPlayer) => standings[teamPlayer.id]?.warnings > 0) || [];
    const expelledPlayers = teamPlayers?.filter((teamPlayer) => standings[teamPlayer.id]?.bans > 0) || [];

    return (
      <Grid item xs={4} style={{ textAlign: "center" }}>
        {goalers.length > 0 && (
          <Grid>
            <RevaText>
              <span role="img" aria-label="goals">
                ⚽
              </span>
              {" Goleadores "}
              <span role="img" aria-label="goals">
                ⚽
              </span>
            </RevaText>
            <RevaText>{goalers.map((player) => `${player.name}(${standings[player.id].goals})`).join(", ")}</RevaText>
          </Grid>
        )}
        {warnedPlayers.length > 0 && (
          <Grid justifyContent="center">
            <RevaText>🟨 Amonestados 🟨</RevaText>
            <RevaText>{warnedPlayers.map((player) => player.name).join(", ")}</RevaText>
          </Grid>
        )}
        {expelledPlayers.length > 0 && (
          <Grid justifyContent="center">
            <RevaText>🟥 Expulsados 🟥</RevaText>
            <RevaText>{expelledPlayers.map((player) => player.name).join(", ")}</RevaText>
          </Grid>
        )}
      </Grid>
    );
  }

  renderDetails() {
    const { classes, onSubmitScore, canEdit, intl } = this.props;
    const { scoresBySet, matchInfo, tournament } = this.state;

    if (!this.state.ready) {
      return (
        <Grid container justifyContent="center" alignItems="center">
          <CircularProgress />
        </Grid>
      );
    }

    const participants = [matchInfo.player1, matchInfo.player2];
    const otherParticipants = [matchInfo.player3, matchInfo.player4];
    const participant1Pic = participants[0] && participants[0].data.full_profile_pic_url;
    const participant2Pic = participants[1] && participants[1].data.full_profile_pic_url;

    const openRegistrations = tournament.open_signup;
    const hasTableScores = Array.isArray(scoresBySet) && scoresBySet.length > 0;

    return (
      <Stack className={classes.detailsPanel}>
        <Stack className={classes.detailsSection}>
          <Stack direction={{ xs: "column", md: "row" }} sx={{ gap: 2, alignItems: "stretch" }}>
            <Card className={classes.teamCard}>
              <Avatar
                variant="rounded"
                src={participant1Pic || RevaLogo}
                alt={participants[0]?.data.display_name}
                className={classes.teamAvatar}
              />
              <RevaText variant="h6" sx={{ fontWeight: 600 }}>
                {participants[0]?.data.name || "-"}
                {matchInfo.player3 && ` | ${matchInfo.player3.data.name}`}
              </RevaText>
            </Card>

            <RevaText className={classes.vsLabel}>vs</RevaText>

            <Card className={classes.teamCard}>
              <Avatar
                variant="rounded"
                src={participant2Pic || RevaLogo}
                alt={participants[1]?.data.display_name}
                className={classes.teamAvatar}
              />
              <RevaText variant="h6" sx={{ fontWeight: 600 }}>
                {participants[1]?.data.name || "-"}
                {matchInfo.player4 && ` | ${matchInfo.player4.data.name}`}
              </RevaText>
            </Card>
          </Stack>

          {hasTableScores && (
            <Stack sx={{ mt: 4 }}>
              <Card className={classes.scoreTableCard}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.scoreHeaderCell}>{intl.formatMessage({ id: "Teams" })}</TableCell>
                      {scoresBySet.map((set, setId) => (
                        <TableCell key={`head-set-${setId + 1}`} align="center" className={classes.scoreHeaderCell}>
                          {intl.formatMessage({ id: "Set" })} {setId + 1}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {participants.map((player, i) => (
                      <TableRow key={i}>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{ minWidth: 160 }}
                          className={classes.scoreDetails}
                        >
                          {(player && player.data.name) || "-"}
                          {otherParticipants[i] && ` | ${otherParticipants[i].data.name}`}
                        </TableCell>
                        {scoresBySet.map((set, setId) => {
                          const currentSet = set.split("-");
                          const teamScore = Number(currentSet[i]);
                          const rivalScore = Number(currentSet[i === 0 ? 1 : 0]);
                          const isWinnerSet = teamScore > rivalScore;
                          return (
                            <TableCell
                              key={`Set ${setId + 1}`}
                              align="center"
                              className={classes.scoreDetails}
                              sx={{
                                fontWeight: isWinnerSet ? 700 : 500,
                                color: isWinnerSet ? "success.main" : "text.primary",
                              }}
                            >
                              {currentSet[i]}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Card>
            </Stack>
          )}

          {canEdit && !openRegistrations && (
            <Stack sx={{ mt: 4 }}>
              {this.state.scheduleError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {this.state.scheduleError}
                </Alert>
              )}
              <Stack className={classes.subPanel} sx={{ gap: 2.5 }}>
                <Stack direction={{ xs: "column", md: "row" }} sx={{ gap: 2 }}>
                  <Grid2 size={{ xs: 12, md: 6 }} sx={{ width: "100%" }}>
                    <DateTimePicker
                      label={intl.formatMessage({ id: "Fecha y hora" })}
                      value={this.state.dateToShow}
                      onChange={(date) => {
                        if (date === null) {
                          this.setState({ dateToShow: null, startDate: null });
                        } else {
                          const startDate = dayjs(date).format("YYYY-MM-DD HH:mm:ss");
                          this.setState({ dateToShow: date, startDate });
                        }
                      }}
                      slotProps={{
                        field: { clearable: true },
                        textField: {
                          fullWidth: true,
                        },
                      }}
                    />
                  </Grid2>

                  <Grid2 size={{ xs: 12, md: 6 }} sx={{ width: "100%" }}>
                    <TextField
                      fullWidth
                      value={this.state.duration}
                      label={intl.formatMessage({ id: "Duración" })}
                      type={"number"}
                      disabled={!this.state.startDate}
                      inputProps={{ min: 1, max: 1440, step: 1 }}
                      helperText={!this.state.startDate ? "Asigna una fecha y hora para fijar la duración." : undefined}
                      onChange={this.handleTextInputChange("duration")}
                      InputProps={{
                        startAdornment: <TimeIcon sx={{ fontSize: 20, mr: 2 }} />,
                        endAdornment: (
                          <InputAdornment position="end">
                            <RevaText id="minutos" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                </Stack>

                <Stack direction={{ xs: "column", md: "row" }} sx={{ gap: 2 }}>
                  <Grid2 size={{ xs: 12, md: 7 }} sx={{ width: "100%" }}>
                    {this.state.spaces && (
                      <FormControl fullWidth disabled={this.state.spaces.length === 0}>
                        <InputLabel id="space-select">{intl.formatMessage({ id: "Sede" })}</InputLabel>
                        <Select
                          label={intl.formatMessage({ id: "Sede" })}
                          value={this.state.selectedSpaceId}
                          startAdornment={<PlaceIcon style={{ fontSize: 16, marginRight: 5 }} />}
                          onChange={this.handleSpaceChange}
                        >
                          {this.state.spaces.map((space) => {
                            return (
                              <MenuItem key={space.id} value={space.id}>
                                {space.display_name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    )}
                    {!this.state.spaces && <CircularProgress size={14}></CircularProgress>}
                  </Grid2>

                  <Grid2 size={{ xs: 12, md: 5 }} sx={{ width: "100%" }}>
                    <Stack className={classes.fieldCard} sx={{ gap: 1.25 }}>
                      <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
                        <RevaText id="Tiene vivo" variant="subtitle2" sx={{ fontWeight: 600 }} />
                        <Switch
                          checked={this.state.hasLive}
                          onChange={(event) => this.handleSwitchChange(event)}
                          color="primary"
                          name="hasLive"
                        />
                      </Stack>
                      {/* <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
                        <RevaText id="En vivo ahora" variant="subtitle2" sx={{ fontWeight: 600 }} />
                        <Switch
                          checked={this.state.liveNow}
                          onChange={(event) => this.handleSwitchChange(event)}
                          color="primary"
                          name="liveNow"
                          disabled={!this.state.hasLive}
                        />
                      </Stack> */}
                      <TextField
                        fullWidth
                        size="small"
                        disabled={!this.state.hasLive}
                        value={this.state.channel_name}
                        label={intl.formatMessage({ id: "Canal de streaming" })}
                        onChange={this.handleTextInputChange("channel_name")}
                      />
                    </Stack>
                  </Grid2>
                </Stack>
              </Stack>
            </Stack>
          )}

          {canEdit && openRegistrations && (
            <RevaText
              sx={{ mt: 3 }}
              id="Podrás asignar la fecha, hora y sede a este partido una vez que comience el torneo."
            />
          )}
        </Stack>

        {canEdit && !openRegistrations && (
          <Stack className={classes.saveSection}>
            <CTAButton sx={{ width: "100%" }} disabled={this.state.savingSchedule} onClick={() => this.update(onSubmitScore)}>
              {intl.formatMessage({ id: "Guardar" })}
            </CTAButton>
          </Stack>
        )}
      </Stack>
    );
  }

  renderScoring() {
    const { matchInfo } = this.state;

    const { isBracketStage, classes, intl } = this.props;
    const { winner, playerScores, savingScore, scoreError } = this.state;
    const scoreIsValid = isValidScoreGrid(playerScores);
    const tieAllowed = !matchInfo?.requires_winner_and_loser;

    if (!matchInfo || !matchInfo.player1 || !matchInfo.player2) {
      return (
        <Stack sx={{ width: "100%", alignItems: "center", p: 4 }}>
          <RevaText variant="h6">
            {intl.formatMessage({ id: "No hay jugadores asignados a este partido todavía." })}
          </RevaText>
        </Stack>
      );
    }

    const participants = [matchInfo.player1, matchInfo.player2];
    const otherParticipants = [matchInfo.player3, matchInfo.player4];

    return (
      <Stack className={classes.detailsPanel}>
        <Stack className={classes.detailsSection}>
          <Stack
            className={classes.controlsBar}
            direction={{ xs: "column", sm: "row" }}
            sx={{
              alignItems: { xs: "flex-start", sm: "center" },
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 2,
              py: 1.5,
              px: 2,
              mb: 3,
            }}
          >
            <Stack direction="row" sx={{ alignItems: "center" }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.hasSuperTiebreak}
                    onChange={(event) => this.handleSwitchChange(event)}
                    color="secondary"
                    name="hasSuperTiebreak"
                  />
                }
                label={
                  <span style={{ fontWeight: 600, fontSize: "14px" }}>
                    {intl.formatMessage({ id: "Último set es súper tie-break" })}
                  </span>
                }
              />
            </Stack>

            <Stack
              direction="row"
              sx={{
                gap: 1.5,
                alignSelf: { xs: "stretch", sm: "auto" },
                justifyContent: { xs: "flex-end", sm: "initial" },
              }}
            >
              <Button
                variant="outlined"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => this.onSetChange("add")}
                sx={{
                  borderRadius: 2,
                  fontWeight: 600,
                  textTransform: "none",
                }}
              >
                {intl.formatMessage({ id: "Agregar set" })}
              </Button>
              {playerScores.length > 1 && (
                <Button
                  variant="outlined"
                  color="error"
                  startIcon={<RemoveIcon />}
                  onClick={() => this.onSetChange("remove")}
                  sx={{
                    borderRadius: 2,
                    fontWeight: 600,
                    textTransform: "none",
                  }}
                >
                  {intl.formatMessage({ id: "Quitar set" })}
                </Button>
              )}
            </Stack>
          </Stack>

          <div className={classes.scoreTableContainer}>
            {scoreError && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {scoreError}
              </Alert>
            )}
            <Card className={classes.scoreTableCard} sx={{ mt: 0 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.scoreHeaderCell}>
                      {intl.formatMessage({ id: "Participante" })}
                    </TableCell>
                    {playerScores.map((set, setId) => {
                      const isLastSet = setId === playerScores.length - 1;
                      const isSuperTiebreak = isLastSet && this.state.hasSuperTiebreak;
                      const defaultLabel = playerScores.length > 1 ? `${setId + 1}` : "";
                      return (
                        <TableCell key={setId} align="center" className={classes.scoreHeaderCell}>
                          {isSuperTiebreak ? (
                            <span style={{ display: "inline-flex", flexDirection: "column", alignItems: "center" }}>
                              <span>{defaultLabel || "1"}</span>
                              <RevaText
                                sx={{
                                  fontSize: "10px",
                                  color: "secondary.main",
                                  textTransform: "uppercase",
                                  fontWeight: 700,
                                }}
                              >
                                Súper TB
                              </RevaText>
                            </span>
                          ) : (
                            defaultLabel
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {participants.map((player, i) => (
                    <TableRow key={player?.data?.id}>
                      <TableCell component="th" scope="row">
                        <RevaText style={{ fontSize: 14 }}>
                          {player?.data?.name || ""}
                          {otherParticipants[i] && ` | ${otherParticipants[i]?.data?.name}`}
                        </RevaText>
                      </TableCell>
                      {playerScores.map((set, setId) => {
                        const isLastSet = setId === playerScores.length - 1;
                        const isSuperTiebreak = isLastSet && this.state.hasSuperTiebreak;
                        return (
                          <TableCell key={setId} align="center" component="th" scope="row">
                            <TextField
                              id="filled-bare"
                              key={`Set ${setId + 1}`}
                              className={classes.score}
                              sx={
                                isSuperTiebreak
                                  ? {
                                      "& .MuiOutlinedInput-root": {
                                        backgroundColor: "secondary.opacity",
                                        "& fieldset": {
                                          borderColor: "secondary.main",
                                          borderWidth: "2px",
                                        },
                                        "&:hover fieldset": {
                                          borderColor: "secondary.main",
                                        },
                                        "&.Mui-focused fieldset": {
                                          borderColor: "secondary.main",
                                        },
                                      },
                                    }
                                  : {}
                              }
                              InputProps={{
                                classes: {
                                  root: classes.scoreInput,
                                },
                              }}
                              margin="normal"
                              type="number"
                              inputProps={{ min: 0, step: 1, inputMode: "numeric", style: { textAlign: "center" } }}
                              variant="outlined"
                              value={set[i]}
                              error={!isValidScoreInput(set[i])}
                              onChange={this.handleChange(setId, i)}
                            />
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Card>
            <Grid container justifyContent="flex-end" sx={{ mt: 1 }}>
              <FormControlLabel
                control={<Checkbox checked={this.state.walkover} onChange={this.handleInputChange} name="walkover" />}
                label={intl.formatMessage({ id: "Ganado por walkover" })}
              />
            </Grid>
          </div>

          <Stack sx={{ alignItems: "center", mt: 4, mb: 1, width: "100%" }}>
            <RevaText
              sx={{
                fontSize: 13,
                fontWeight: 700,
                letterSpacing: 0.8,
                textTransform: "uppercase",
                color: "text.secondary",
                mb: 1.5,
                textAlign: "center",
              }}
            >
              {intl.formatMessage({ id: "¿Quién ganó?" })}
            </RevaText>
            <Stack
              direction={{ xs: "column", md: "row" }}
              sx={{
                width: "100%",
                maxWidth: 800,
                gap: 2,
                alignItems: "stretch",
                justifyContent: "center",
              }}
            >
              {/* Option 1: Participant 1 */}
              <Card
                className={`${classes.winnerCard} ${
                  winner === participants[0]?.data?.id ? classes.winnerCardSelected : ""
                }`}
                onClick={() => this.setState({ winner: participants[0]?.data?.id })}
              >
                {winner === participants[0]?.data?.id && <CheckCircleIcon color="primary" sx={{ fontSize: 20 }} />}
                <RevaText sx={{ fontWeight: 600, fontSize: "15px" }}>
                  {participants[0]?.data?.name || ""}
                  {otherParticipants[0] && ` | ${otherParticipants[0]?.data?.name}`}
                </RevaText>
              </Card>

              {/* Option 2: Tie (Empate) - Only if not bracket stage */}
              {!isBracketStage && tieAllowed && (
                <Card
                  className={`${classes.winnerCard} ${winner === TIE ? classes.winnerCardSelected : ""}`}
                  onClick={() => this.setState({ winner: TIE })}
                >
                  {winner === TIE && <CheckCircleIcon color="primary" sx={{ fontSize: 20 }} />}
                  <span style={{ fontSize: "18px" }}>🤝</span>
                  <RevaText sx={{ fontWeight: 600, fontSize: "15px" }}>
                    {intl.formatMessage({ id: "Marcar como empate" })}
                  </RevaText>
                </Card>
              )}

              {/* Option 3: Participant 2 */}
              <Card
                className={`${classes.winnerCard} ${
                  winner === participants[1]?.data?.id ? classes.winnerCardSelected : ""
                }`}
                onClick={() => this.setState({ winner: participants[1]?.data?.id })}
              >
                {winner === participants[1]?.data?.id && <CheckCircleIcon color="primary" sx={{ fontSize: 20 }} />}
                <RevaText sx={{ fontWeight: 600, fontSize: "15px" }}>
                  {participants[1]?.data?.name || ""}
                  {otherParticipants[1] && ` | ${otherParticipants[1]?.data?.name}`}
                </RevaText>
              </Card>
            </Stack>
          </Stack>
        </Stack>
        <Stack className={classes.saveSection}>
          <CTAButton
            variant="contained"
            color="secondary"
            disabled={!winner || !scoreIsValid || savingScore}
            sx={{ width: "100%" }}
            onClick={() => this.updateMatch()}
          >
            {savingScore
              ? intl.formatMessage({ id: "Guardando..." })
              : intl.formatMessage({ id: matchInfo.state === CLOSED ? "Actualizar ganador" : "Finalizar partido" })}
          </CTAButton>
        </Stack>
      </Stack>
    );
  }

  render() {
    const { matchInfo } = this.state;
    const { showScoreTab, classes, intl } = this.props;
    const { tabIndex, showScoreDetailsTab } = this.state;

    if (!this.state.ready || !matchInfo) {
      return (
        <Grid container justifyContent="center" alignContent="center">
          <CircularProgress size={24} />
        </Grid>
      );
    }

    return (
      <Stack sx={{ p: 3, borderRadius: 2 }}>
        <RevaText variant="subtitle1" sx={{ mb: 2 }}>
          {formatMatchIdentity(matchInfo, (id, values) => intl.formatMessage({ id }, values))}
        </RevaText>
        <Tabs
          value={tabIndex}
          classes={{ flexContainer: classes.tabs }}
          indicatorColor="primary"
          textColor="inherit"
          onChange={(event, value) => this.setState({ tabIndex: value })}
        >
          <Tab label={intl.formatMessage({ id: "Información" })} />
          {showScoreTab && <Tab label={intl.formatMessage({ id: "Resultados" })} />}
          {showScoreTab && showScoreDetailsTab && <Tab label={intl.formatMessage({ id: "Detalles" })} />}
        </Tabs>
        {tabIndex === 0 && this.renderDetails()}

        {tabIndex === 1 && this.renderScoring()}

        {tabIndex === 2 && <MatchScoreDetails match={matchInfo} />}
      </Stack>
    );
  }
}

export default withUserContext(withStyles(styles)(injectIntl(EditMatchModal)));
